import {createLog} from '../util/BannerCommon';
import {getBannerStatLogger, getErrorOperationWithSuffix} from '../util/BannerStat';

import type {IBanner} from './IBanner';

const OP_INIT_VISIBLE = 0;
const OP_INIT_INVISIBLE = 1;
const OP_SHOW = 2;
const OP_HIDE = 3;
const OP_DESTROY = 4;

const log = createLog('BannerProxy');

interface IBannerProxyOptions {
    createDelegate: () => IBanner;
    key: () => string;
    slot: string;
}

export class BannerProxy implements IBanner {
    options: IBannerProxyOptions;
    delegate: IBanner | null = null;
    ops: number[] | null = null;

    constructor(options: IBannerProxyOptions) {
        this.options = options;
    }

    init(visible: boolean) {
        if (this.ops === null) {
            const logger = getBannerStatLogger();
            this.ops = [];
            this.ops.push(visible ? OP_INIT_VISIBLE : OP_INIT_INVISIBLE);

            try {
                this.delegate = this.options.createDelegate();
                log('delegate', this.delegate);
            } catch (exception) {
                const ex = exception as Error;
                log('error', ex);
                logger.errorEx(
                    ex,
                    "BannerProxy",
                    "delegate_init_" + this.options.key(),
                    getErrorOperationWithSuffix(this.options.slot)
                );
                return;
            }
            for (let i = 0; i < this.ops.length; i++) {

                const op = this.ops[i];

                log('op', op);

                if (this.delegate === null) {
                    return;
                }

                try {
                    switch (op) {
                        case OP_INIT_VISIBLE:
                            this.delegate.init(true);
                            break;
                        case OP_INIT_INVISIBLE:
                            this.delegate.init(false);
                            break;
                        case OP_SHOW:
                            this.delegate.show();
                            break;
                        case OP_HIDE:
                            this.delegate.hide();
                            break;
                        case OP_DESTROY:
                            this.delegate.destroy();
                            break;
                        default:
                    }
                } catch (exception) {
                    const ex = exception as Error;
                    log('error', ex);
                    logger.errorEx(
                        ex,
                        "BannerProxy",
                        `delegate_replay_${op}`,
                        getErrorOperationWithSuffix(this.options.slot)
                    );
                    return;
                }
            }

        }
    }

    show() {
        if (this.delegate !== null) {
            this.delegate.show();
        } else {
            this.ops?.push(OP_SHOW);
        }
    }

    hide() {
        if (this.delegate !== null) {
            this.delegate.hide();
        } else {
            this.ops?.push(OP_HIDE);
        }
    }

    destroy() {
        if (this.delegate !== null) {
            this.delegate.destroy();
            this.delegate = null;
        } else {
            this.ops?.push(OP_DESTROY);
        }
    }
}
